import { ENCYCLOPEDIA } from 'constants/popups';
import { PopupName } from 'types';
import { Store } from 'stores/type';
import { isChromeIOS } from 'utils';
import * as history from 'helpers/browser-history';
import EventsManager from 'managers/events.manager';
import ScrollManager from 'managers/scroll.manager';

const IS_CHROME_IOS = isChromeIOS();

class PopupsManager {
  private $store!: Store;

  public init(store: Store) {
    this.$store = store;
    this.initHideListeners();
  }

  private initHideListeners() {
    EventsManager.on('KEY_ESC', this.handleKeyboard);
    EventsManager.on('BACK_BUTTON', this.handleKeyboard);
  }
  private handleKeyboard = () => {
    if (!this.$store.getters.isPopupClosable) return;

    this.hide();
  }

  public hide() {
    if (!this.$store.getters.isPopupActive) return;

    this.$store.dispatch('popupHide', undefined);
  }

  public onShow(name: PopupName) {
    history.push();
    EventsManager.emit('POPUP_SHOW', name);
    if (ScrollManager.handler) {
      ScrollManager.handler.disable();
    }
  }
  public onHide(name: PopupName) {
    if (!IS_CHROME_IOS) {
      history.pop();
    }

    EventsManager.emit('POPUP_HIDE', name);
    if (ScrollManager.handler) {
      ScrollManager.handler.enable();
    }

    if (name === ENCYCLOPEDIA) {
      EventsManager.emit('ENCYCLOPEDIA_POPUP_HIDE');
    }
  }
  public onHidePromise() {
    if (!this.$store.getters.isPopupOverlayActive) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const unwatch = this.$store.watch(
        (_state, getters) => getters.isPopupOverlayActive,
        (active) => {
          if (active) return;

          unwatch();
          resolve();
        },
      );
    });
  }
}

export default new PopupsManager();
